import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { FlowType } from "@modules/uk-finprom/components/customer-segmentation/customer-segmentation.component";

export interface InputFieldStatus {
	inputFieldDisabled: boolean;
	inputFieldHasValue: boolean;
	noOptionSelected: boolean;
}

export interface InputStatus {
	[key: string]: InputFieldStatus;
}

@Injectable({
	providedIn: "root"
})
export class CustomerSegmentationService {
	public inputFieldsSubject: BehaviorSubject<InputStatus> = new BehaviorSubject<InputStatus>({});
	public nextButtonSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

	public inputFieldStatus$: Observable<InputStatus> = this.inputFieldsSubject.asObservable();

	public toggleInputField(id: number, dataToUpdate: InputFieldStatus): void {
		const currentState = this.inputFieldsSubject.getValue();

		const updateState = {
			...currentState,
			[id]: dataToUpdate
		};

		this.inputFieldsSubject.next(updateState);

		const inputFieldsHaveValue = Object.values(updateState);
		const inputFieldsHaveTrueValue =
			inputFieldsHaveValue.length > 0 &&
			inputFieldsHaveValue.every((value: InputFieldStatus) => value.inputFieldHasValue || value.noOptionSelected);

		this.nextButtonSubject.next(!inputFieldsHaveTrueValue);
	}

	public noOptionSelected(flowId: number): boolean {
		const currentState: InputStatus = this.inputFieldsSubject.getValue();

		if (flowId === FlowType.RESTRICTED) {
			return Object.values(currentState).some((state) => state.noOptionSelected);
		}

		return Object.values(currentState).every((state) => state.noOptionSelected);
	}
}
